import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=d227ddf2&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=d227ddf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d227ddf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d227ddf2')) {
      api.createRecord('d227ddf2', component.options)
    } else {
      api.reload('d227ddf2', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=d227ddf2&scoped=true&", function () {
      api.rerender('d227ddf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2s02Cl9xpJo5s/JS/comp/PopupDialog.vue"
export default component.exports